module.exports = __webpack_public_path__ + "img/full4-min.e5e20efd.png";